module.exports = __webpack_public_path__ + "static/media/2 (29).f8a53ab3.jpg";